import { BASE_URL } from '../components/AppConfig';

const getAuthToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  return sessionToken ? `Bearer ${sessionToken}` : '';
};

const authFetch = async (path, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const res = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
        ...(options.headers || {}),
      },
      ...options,
    });
    return res.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

const authMultipartFetch = async (path, formData, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }

  try {
    const res = await fetch(`${BASE_URL}${path}`, {
      credentials: 'include',
      headers: {
        Authorization: token,
        ...(options.headers || {}),
      },
      ...options,
      body: formData,
    });
    return res.json().catch(() => ({}));
  } catch {
    return { statusCode: '50000', message: 'Request failed' };
  }
};

export const isFanLoungeApiSuccess = (res) =>
  String(res?.statusCode || '') === '10000' || res?.statusCode == null;

export const getFanLoungePayload = (res) => res?.data ?? null;

/** GET /admin/fan-lounge/dashboard */
export const getFanLoungeDashboard = () =>
  authFetch('/admin/fan-lounge/dashboard', { method: 'GET' });

/** GET /admin/fan-lounge/players */
export const listFanLoungePlayers = ({ teamId } = {}) => {
  const params = new URLSearchParams();
  if (teamId != null) params.set('team_id', String(teamId));
  const query = params.toString();
  return authFetch(`/admin/fan-lounge/players${query ? `?${query}` : ''}`, { method: 'GET' });
};

/** POST /admin/fan-lounge/upload-image */
export const uploadFanLoungeImage = (imageFile) => {
  const formData = new FormData();
  formData.append('image', imageFile);
  return authMultipartFetch('/admin/fan-lounge/upload-image', formData, { method: 'POST' });
};

/** POST /admin/fan-lounge/players */
export const createFanLoungePlayer = (body) =>
  authFetch('/admin/fan-lounge/players', { method: 'POST', body: JSON.stringify(body) });

export const createFanLoungePlayerMultipart = (formData) =>
  authMultipartFetch('/admin/fan-lounge/players', formData, { method: 'POST' });

/** PATCH /admin/fan-lounge/players/:player_id */
export const updateFanLoungePlayer = (playerId, body) =>
  authFetch(`/admin/fan-lounge/players/${playerId}`, {
    method: 'PATCH',
    body: JSON.stringify(body),
  });

export const updateFanLoungePlayerMultipart = (playerId, formData) =>
  authMultipartFetch(`/admin/fan-lounge/players/${playerId}`, formData, { method: 'PATCH' });

/** DELETE /admin/fan-lounge/players/:player_id */
export const removeFanLoungePlayer = (playerId) =>
  authFetch(`/admin/fan-lounge/players/${playerId}`, { method: 'DELETE' });

/** PATCH /admin/fan-lounge/players/reorder */
export const reorderFanLoungePlayers = (body) =>
  authFetch('/admin/fan-lounge/players/reorder', {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
